import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import Body from './Components/Body/Body';
import { useEffect, useState } from 'react';
import axios from 'axios';
function App() {
  const [city,setCity]=useState("new Delhi");
  const [weatherData,setWeatherData]=useState(null);

  useEffect(()=>{
    axios.get(`https://api.weatherapi.com/v1/current.json?key=eda58078a512437abdc162155242709&q=${city}&aqi=no`).then((success)=>{
      console.log(success.data);
      setWeatherData(success.data);
    }).catch((error)=>{
      console.log(error);
      alert("please Enter Valid city...!");
    });
  },[city]);
  return (
    <div className="App">
      {weatherData && <Body setCity={setCity} city={city} stat={{
        temp:weatherData.current.temp_c,
        text:weatherData.current.condition.text,
        cityName:weatherData.location.name,
        country:weatherData.location.country,
        humdi:weatherData.current.humidity,
        winds:weatherData.current.wind_kph,
        visib:weatherData.current.vis_km,
        is_day:weatherData.current.is_day
      }}
      />}
    </div>
  );
}

export default App;
